import { shallowEqual, useSelector } from 'react-redux';

import { doRequest } from '@r1-frontend/do-request/index';
import { makePaymentAuth, makePaymentUnauth } from '@r1-frontend/api-domru/api-pay/v1/payment/add';
import { IRegisterPayment } from '@r1-frontend/api-domru/api-pay/v1/payment/dto/IRegisterPayment';

import { selectCardPaySum } from '~/src/features/payments-abn/components/SeasonTicketPayment/store/selectors/selectPaymentSum';
import { TState } from '~/src/store';

/**
 * Возвращает метод для оплаты через СберПэй
 */
export const useSberPayMethod = () => {
    const {
        isAuth,
        providerId,
        phone,
        agreement,
        agreementEnc,
        paymentSum,
    } = useSelector((state: TState) => {
        const paymentSum = selectCardPaySum(state);

        return {
            isAuth: state.auth.isAuth,
            providerId: state.city.provider.providerId,
            phone: state.payment.paymentData.phone,
            agreement: state.payment.paymentData.agreement,
            agreementEnc: state.payment.paymentData.agreementEnc,
            paymentSum,
        };
    }, shallowEqual);

    const isValid = isAuth ? !!(phone && paymentSum) : !!(phone && paymentSum && (agreement || agreementEnc));
    const paymentSource = isAuth ? 2 : 1;

    const sendSberPay = async() => {
        if (!isValid) {
            return false;
        }

        const params: Record<string, unknown> = {
            mobile_phone: phone,
            payment_value: paymentSum,
            payment_source: paymentSource,
            agreement_enc: agreementEnc,
            number_value: agreement,
            back2app: 1,
        };

        const resp = await doRequest.apiPay<IRegisterPayment>(
            isAuth ? makePaymentAuth(providerId, params) : makePaymentUnauth(providerId, params),
        );

        return resp.isSuccess && resp.payload.regStatus > 0;
    };

    return {
        isValid,
        sendSberPay,
    };
};
